import api from "../api/api";
import { applySentryUser } from "../sentry";

export const USER_SESSION = "USER_SESSION";
export const UNMNG_SCTR_GB_LIST = [
  "005",
  "007",
  "008",
  "009",
  "010",
  "011",
  "014",
  "015",
];
// export const EMPTY_CMPNY_LIST = [44, 776, 777, 778, 779, 780, 781, 782, 783, 784, 785, 786, 787, 788, 789, 790, 791];
// const emptyCmpny = EMPTY_CMPNY_LIST.includes(user.companySeq);
export const INIT_PSWRD = "0000";

export function findByPhoneOrUserId(phoneOrUserId: string, callback: any) {
  api
    .findByPhoneOrUserId(phoneOrUserId)
    .then((r: boolean) => {
      callback(r);
    })
    .catch(console.error);
}

export async function login(phoneOrUserId: any, userAuth: any, inputPassword:any, callback: any) {
  await api
    .login(phoneOrUserId, userAuth, inputPassword)
    .then((user) => {
      if (user && !user.loginFail) {
        sessionStorage.setItem(USER_SESSION, JSON.stringify(user));
        applySentryUser(user);
      }
      callback(user);
    })
    .catch(console.error);
}
export function logout() {
  // eslint-disable-next-line no-restricted-globals
  if (confirm("로그아웃 하시겠습니까?")) {
    sessionStorage.removeItem(USER_SESSION);
    applySentryUser(null);
    window.location.href = "/";
  }
}
export function logoutWC() {
  sessionStorage.removeItem(USER_SESSION);
  applySentryUser(null);
  window.location.href = "/";
}
export function getLoginUser() {
  var user = sessionStorage.getItem(USER_SESSION);
  if (user === null) {
    if (window.location.pathname !== "/") {
      const hadLegacySession = localStorage.getItem(USER_SESSION) !== null;
      if (hadLegacySession) {
        localStorage.removeItem(USER_SESSION);
        // 레거시(보안 업데이트) 세션 정리 시에만 안내.
        // 신규 방문(세션 없음)은 안내 없이 로그인으로 이동하고,
        // 실제 세션 만료 안내는 401 처리(sentry.ts)에서 띄움.
        sessionStorage.setItem(
          "FLASH_SNACK",
          "보안 업데이트로 인해 다시 로그인이 필요합니다."
        );
      }
      window.location.href = "/";
    }
    return null;
  }
  return JSON.parse(user);
}

export function loginByKakaoId(kakaoId: string, callback: any) {
  api
    .checkKakaoId(kakaoId)
    .then((user) => {
      sessionStorage.setItem(USER_SESSION, JSON.stringify(user));
      applySentryUser(user);
      callback(user);
    })
    .catch(console.error);
}

// export function loginByPhone(phone: string, callback: any) {
//     api
//         .checkPhone(phone)
//         .then((user) => {
//             sessionStorage.setItem(USER_SESSION, JSON.stringify(user));
//             callback(user);
//         })
//         .catch(console.error);
// }

// export async function rememberLogin(
//   phoneOrUserId: any,
//   password: any,
//   callback: any
// ) {
//   await api
//     .login(phoneOrUserId, password)
//     .then((user) => {
//       localStorage.setItem(USER_SESSION, JSON.stringify(user));
//       callback(user);
//     })
//     .catch(console.error);
// }